
const headers = [
    {
      label: 'ชื่อ - นามสกุล',
      field: 'fullname',
    },
    {
      label: 'อีเมล',
      field: 'email',      
    },
    {
      label: 'เบอร์โทรศัพท์',
      field: 'tel', 
    },
  ]

  export default headers